import React from 'react';
import * as _ from 'lodash';
import splitViewManager from '../utilities/splitViewManager';
import urlParamManger from '../utilities/urlParamManager';
import * as pages from './pageComponents';
import EventManager, { EventType } from '../utilities/EventManager';

import { FieldTreeService } from '../services/FieldTrees';

export default class LaborSafetyFuncNavi extends React.Component {
  constructor(props) {
    super(props);

    this.settingPages = Object.keys(pages.setting); //設定系画面
    this.singlePages = [
      'FieldTree',
      'Dashboard',
      'SafetyDiaries',
      'ConstructionPlacementPlace',
      'Layout',
    ]; //分割しない画面
    this.singlePages = _.concat(this.singlePages, this.settingPages);
    this.pages = _.merge(pages, pages.setting);
    //delete this.pages.setting;//エラる

    this.state = {
      multiview: true, //マルチビューの状態
      railnavi: sessionStorage.getItem('is_conference') ? true : false, //メニューの状態
      fieldId: sessionStorage.getItem('field_id'),
      page: '', //ページコンポーネント名
      formCodeCount: [],
    };

    /**
     * 分割画面のパラメータ
     */
    urlParamManger.setDelegate(urlparam => {
      if (
        //現在と違うページの場合に更新
        urlparam[this.props.vw - 1] &&
        this.state.page.split(':')[0] !=
          urlparam[this.props.vw - 1].split(':')[0]
      ) {
        this.setState({ page: urlparam[this.props.vw - 1] });
        this.loadPage(urlparam[this.props.vw - 1]);
        EventManager.trigger(EventType.LAYOUT_UPDATE, {});
      }
    });
  }

  componentDidMount() {
    EventManager.addEventListener(EventType.CONFERENCE_MODE, conference => {
      this.setState({ railnavi: !conference });
      EventManager.trigger(EventType.LAYOUT_UPDATE, {});
    });
  }

  /**
   * サイドメニューの開閉
   * @param {boolean} b
   */
  naviStatus(b) {
    this.setState({ railnavi: b });
    EventManager.trigger(EventType.LAYOUT_UPDATE, {});
  }

  /**
   * ページのロード
   * @param { string } page
   */
  loadPage(page) {
    if (!page) {
      return;
    }

    let pageparam = page.split(':');

    //シングルページの場合 splitViewManagerに通知
    const regexp = new RegExp(`^(${this.singlePages.join('|')}).*`, 'g');
    if (pageparam[0].split(':')[0].match(regexp) ? true : false) {
      splitViewManager.forceSingleViewUpdate();
    }

    //ページをコンポーネントをロード
    const _settingPage = _.filter(this.settingPages, settingPage => {
      return settingPage == pageparam[0];
    });
    if (_settingPage.length) {
      this.props.loadSettingPage(this.pages[pageparam[0]], pageparam);
    } else {
      this.props.loadPage(this.pages[pageparam[0]], pageparam);
    }

    //pushstateしてurlを書き換え
    urlParamManger.setPage(page, this.props.vw);
    this.setState({ page });
    setTimeout(() => {
      EventManager.trigger(EventType.LAYOUT_UPDATE, {});
    }, 1);
    this.getCountUnapproved();
  }

  //1画面判定正規表現
  regexp() {
    return new RegExp(`^(${this.singlePages.join('|')}).*`, 'g');
  }

  //分割メニューの表示非表示
  splitviewMenu() {
    return this.state.page.match(this.regexp())
      ? { display: 'none' }
      : { display: 'flex' };
  }

  getCountUnapproved() {
    FieldTreeService.countUnapproved(this.state.fieldId).then(resp => {
      if (resp.result) {
        this.setState({ formCodeCount: resp.data.entities.form_code_count });
      }
    });
  }

  render() {
    const railside = classname => {
      return this.state.railnavi ? `${classname} show` : classname;
    };
    /* eslint-disable no-unused-vars */

    const multiview = classname => {
      return this.state.multiview ? `${classname} selected` : classname;
    };
    const singleview = classname => {
      return !this.state.multiview ? `${classname} selected` : classname;
    };
    /* eslint-enable no-unused-vars */
    const itemSelected = page => {
      if (
        _.size(
          _.filter(this.settingPages, p => {
            return p === this.state.page.split(':')[0];
          })
        ) &&
        page === 'settingPage'
      ) {
        return 'line-list line-list--list select'; //各種設定
      }
      return page === this.state.page.split(':')[0]
        ? 'line-list line-list--list select'
        : 'line-list line-list--list';
    };

    return (
      <div
        id={`func-navi--item${this.props.vw}`}
        className={railside('rail__side')}
      >
        <div className='rail__navi'>
          <div
            id='func-navi--item1-btn-open'
            className='btn-rail-navi btn--rail__show'
            onClick={() => {
              this.naviStatus(true);
            }}
          >
            <i className='i-warrow-right i-2x' alt='開く' aria-hidden='true' />
          </div>
          <div
            id='func-navi--item1-btn-close'
            className='btn-rail-navi btn--rail__hide'
            onClick={() => {
              this.naviStatus(false);
            }}
          >
            <i className='i-warrow-left i-2x' alt='閉じる' aria-hidden='true' />
          </div>
        </div>
        <div className='rail__menu'>
          <div className='func-navi'>
            <ul className='list list--func-navi'>
              <h2 className='list__header'>
                機能一覧
                <ul className='bar-menu bar-menu--func-navi'>
                  <li className='bar-menu__item sys-splitview-single' />
                  <li className='bar-menu__item selected sys-splitview-multi' />
                </ul>
              </h2>
              <div className='list__scroll'>
                <li className='list__item'>
                  <div
                    className={itemSelected('FieldTree')}
                    onClick={() => {
                      this.loadPage('FieldTree');
                    }}
                  >
                    <div className='icon icon--line-list'>
                      <i className='i-sekoutaikei' aria-hidden='true' />
                    </div>
                    施工体系図
                  </div>
                </li>
                <li className='list__item'>
                  <div className='line-list--sub'>安全書類の確認・出力</div>
                </li>
                <li className='list__item'>
                  <div
                    className={itemSelected('ConstructionWorkNotifyDetail')}
                    onClick={() => {
                      this.loadPage('ConstructionWorkNotifyDetail');
                    }}
                  >
                    <div className='icon icon--line-list'>
                      <FormCodeCount count={this.state.formCodeCount} no={2} />
                      <i className='i-cyouhyou' aria-hidden='true' />
                    </div>
                    <span className='list__item--two'>
                      <div className='list__item--two-item'>
                        施工体系台帳作成
                      </div>
                      <div className='list__item--two-item'>建設工事の通知</div>
                    </span>
                  </div>
                </li>
                <li className='list__item'>
                  <a href='' className='line-list line-list--list'>
                    <div className='icon icon--line-list'>
                      <FormCodeCount count={this.state.formCodeCount} no={1} />
                      <i className='i-cyouhyou' aria-hidden='true' />
                    </div>
                    <span className='list__item--two'>
                      <div className='list__item--two-item'>
                        工事作業所災害防止
                      </div>
                      <div className='list__item--two-item'>
                        協議会兼施工体系図
                      </div>
                    </span>
                  </a>
                </li>
                <li className='list__item'>
                  <div
                    className={itemSelected('WorkLedger')}
                    onClick={() => {
                      this.loadPage('WorkLedger');
                    }}
                  >
                    <div className='icon icon--line-list'>
                      <FormCodeCount count={this.state.formCodeCount} no={3} />
                      <i className='i-cyouhyou' aria-hidden='true' />
                    </div>
                    施工体系台帳
                  </div>
                </li>
                <li className='list__item'>
                  <div
                    className={itemSelected('SubcontractReNotify')}
                    onClick={() => {
                      this.loadPage('SubcontractReNotify');
                    }}
                  >
                    <div className='icon icon--line-list'>
                      <FormCodeCount count={this.state.formCodeCount} no={4} />
                      <i className='i-cyouhyou' aria-hidden='true' />
                    </div>
                    再下請負通知書
                  </div>
                </li>
                <li className='list__item'>
                  <div
                    className={itemSelected('SubcontractorsTable')}
                    onClick={() => {
                      this.loadPage('SubcontractorsTable');
                    }}
                  >
                    <div className='icon icon--line-list'>
                      <FormCodeCount count={this.state.formCodeCount} no={5} />
                      <i className='i-cyouhyou' aria-hidden='true' />
                    </div>
                    下請負業者編成表
                  </div>
                </li>
                <li className='list__item'>
                  <a href='' className='line-list line-list--list'>
                    <div className='icon icon--line-list'>
                      <FormCodeCount count={this.state.formCodeCount} no={6} />
                      <i className='i-cyouhyou' aria-hidden='true' />
                    </div>
                    作業員名簿
                  </a>
                </li>
                <li className='list__item'>
                  <a href='' className='line-list line-list--list'>
                    <div className='icon icon--line-list'>
                      <FormCodeCount count={this.state.formCodeCount} no={7} />
                      <i className='i-cyouhyou' aria-hidden='true' />
                    </div>
                    社会保険加入状況
                  </a>
                </li>
                <li className='list__item'>
                  <a href='' className='line-list line-list--list'>
                    <div className='icon icon--line-list'>
                      <FormCodeCount count={this.state.formCodeCount} no={8} />
                      <i className='i-cyouhyou' aria-hidden='true' />
                    </div>
                    <span className='list__item--two'>
                      <div className='list__item--two-item'>
                        外国人建設就労者
                      </div>
                      <div className='list__item--two-item'>建設現場入場届</div>
                    </span>
                  </a>
                </li>
                <li className='list__item'>
                  <a href='' className='line-list line-list--list'>
                    <div className='icon icon--line-list'>
                      <i className='i-cyouhyou' aria-hidden='true' />
                    </div>
                    <span className='list__item--two'>
                      <div className='list__item--two-item'>
                        新規入場者等教育
                      </div>
                      <div className='list__item--two-item'>実施報告書</div>
                    </span>
                  </a>
                </li>
                <li className='list__item'>
                  <a href='' className='line-list line-list--list'>
                    <div className='icon icon--line-list'>
                      <i className='i-cyouhyou' aria-hidden='true' />
                    </div>
                    その他の安全書類
                  </a>
                </li>
              </div>
            </ul>
          </div>
        </div>
      </div>
    );
  }
}

const FormCodeCount = ({ count, no }) => {
  if (count.length !== 0) {
    const code = no - 1;
    return (
      <button className='labor-safety-status-ticket'>
        {count[code][`form_code_${no}`]}
      </button>
    );
  } else {
    return null;
  }
};



// WEBPACK FOOTER //
// ./src/components/laborSafetyFuncNavi.jsx